export default __webpack_public_path__ + "static/media/nosound.e73bcc80.mp3";